import { IHardwareStatusSummaryResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQueryResult,
    DataSourceRequest,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

const defaultHardwareSort: DataSourceSort[] = [
    { field: 'Location.LocationName', dir: 'asc' },
];

export type CorporationHardwareStatusFilter = {
    corporationId: string;
    locationIds?: string[];
};

export type UseCorporationHardwareStatusDataSourceOptions = BaseDataSourceOptions<
    IHardwareStatusSummaryResponse,
    CorporationHardwareStatusFilter
>;

function getHardwareStatus({
    sort,
    filter,
    page,
    pageLimit,
}: DataSourceRequest<CorporationHardwareStatusFilter>): Promise<
    DataSourceQueryResult<IHardwareStatusSummaryResponse>
> {
    return toDataSourceResult(
        sdClient.getCorporationHardwareSummaryStatus({
            corporationId: filter.corporationId,
            filter: filter.locationIds
                ? Filter.in('Location.LocationId', filter.locationIds)
                : undefined,
            page,
            pageLimit,
            orderBy: buildOrderBy(sort),
        })
    );
}

export type CorporationHardwareStatusInfiniteDataSource = InfiniteDataSource<
    IHardwareStatusSummaryResponse,
    CorporationHardwareStatusFilter
>;

export function useInfiniteCorporationHardwareStatusDataSource({
    defaultSort = defaultHardwareSort,
    ...options
}: UseCorporationHardwareStatusDataSourceOptions): CorporationHardwareStatusInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: getHardwareStatus,
    });
}
